module.exports = __webpack_public_path__ + "img/flag.e153a08c.svg";